import { BaseMaintenanceBloc } from "./bloc.base";

export class CloudMaintenanceBloc extends BaseMaintenanceBloc {
}

